<script setup>
import InvestmentSummaryTable from '../investmentAmount/InvestmentSummaryTable.vue'
import InvestmentProcessNavigationButtons from '../InvestmentProcessNavigationButtons.vue'
import InvestmentPaymentMethods from '../investmentPayment/InvestmentPaymentMethods.vue'
import { trackAnalyticsInvestmentProcessStep4 } from '../../../utilities/useTracking'
import { onMounted } from 'vue'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { navigateToLandingPage, navigateToOrders } from '../../../utilities/account/useInvestmentProcessNavigation'
import { isLegalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { MembershipDocumentStatus } from '../../../typings'
import MembershipDocument from '../../account/membershipManagement/MembershipDocument.vue'
import { isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { useLegalAccountDataState } from '../../../utilities/account/useAccountDataLegal'
import { ref } from 'vue'
import { getPlatformSettings } from '../../../utilities/usePlatformSettings'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import GiftMembershipFaqPanel from '../../account/membershipManagement/GiftMembershipFaqPanel.vue'
import { isCertificateEnabled } from '../../../utilities/usePlatformSettings'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import SecupayPaymentWrapper from '../secupay/SecupayPaymentWrapper.vue'

const personalAccountDataStore = usePersonalAccountDataState()
const accountStateNatural = usePersonalAccountDataState()
const accountStateLegal = useLegalAccountDataState()
const account = ref(null)

const campaignData = getCampaignData()
const showNavigationButtons = ref(true)

onMounted(() => {
    trackAnalyticsInvestmentProcessStep4()
    if (isNaturalProfile()) {
        accountStateNatural.fetchAccountData()
        account.value = accountStateNatural.naturalProfile
    } else {
        accountStateLegal.fetchAccountData()
        account.value = accountStateLegal.legalProfile
    }

    if (campaignData.asset_data.deactivate_payment_account) {
        showNavigationButtons.value = true
    } else {
        showNavigationButtons.value = false
    }
})
</script>

<template>
    <div class="px-4 py-6 sm:p-6 lg:p-8">
        <h3 class="text-xl font-semibold text-primary">{{ $t('investment_process.thank_you_for_you_investment') }}</h3>
        <div class="mb-4 mt-2 border-t border-gray-300"></div>
        <div class="space-y-4">
            <InvestmentSummaryTable read-only />
            <div
                v-if="
                    getPlatformSettings().membership_management_active &&
                    account &&
                    account.membership_document[0]?.status !== MembershipDocumentStatus.ACCEPTED
                "
                class="rounded-lg border">
                <MembershipDocument
                    v-if="!isCertificateEnabled() && !useInvestmentProcessDataState().createdOrder.is_gift" />
                <GiftMembershipFaqPanel v-if="useInvestmentProcessDataState().createdOrder.is_gift" />
            </div>
            <InvestmentPaymentMethods
                v-if="
                    campaignData.asset_data.deactivate_payment_account ||
                    useInvestmentProcessDataState().createdOrder.payment_account_type === 'lemonway'
                "
                :show-kyc-alert="personalAccountDataStore.naturalProfile.kyc_id === false && !isLegalProfile()"
                :show-credit-card="personalAccountDataStore.naturalProfile.kyc_id === true"
                :show-wire-transfer="personalAccountDataStore.naturalProfile.kyc_id === true" />
        </div>
        <SecupayPaymentWrapper
            v-if="
                !campaignData.asset_data.deactivate_payment_account &&
                useInvestmentProcessDataState().createdOrder.payment_account_type === 'secupay'
            "
            class="mt-6"
            @payment-finished="showNavigationButtons = true" />
        <div
            v-if="showNavigationButtons"
            class="mt-4 flex h-20 w-full flex-col items-center justify-start space-y-4 md:hidden">
            <BaseButtonMuted class="w-full" :sticky="false" @click="navigateToLandingPage()">{{
                $t('investment_process.to_the_landing_page')
            }}</BaseButtonMuted>
            <BaseButtonPrimary class="w-full" :sticky="false" @click="navigateToOrders()">{{
                $t('investment_process.go_to_my_orders')
            }}</BaseButtonPrimary>
        </div>
        <div v-if="showNavigationButtons" class="hidden md:block">
            <InvestmentProcessNavigationButtons
                :on-back-click="navigateToLandingPage"
                :back-button-text="$t('investment_process.to_the_landing_page')"
                :on-next-click="navigateToOrders"
                :next-button-text="$t('investment_process.go_to_my_orders')" />
        </div>
    </div>
</template>

<style scoped></style>
